import { Link } from "react-router-dom";
import type { Novel } from "@/lib/novel";

interface ChapterListProps {
  novel: Novel;
}

export default function ChapterList({ novel }: ChapterListProps) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">
      {novel.chapters.map((chapter) => (
        <Link
          key={chapter.id}
          to={`/read/${novel.id}/${chapter.chapterId}`}
          className="group flex items-center gap-2 rounded-md border border-background-200 bg-background-50 px-3 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <span className="flex h-5 w-5 shrink-0 items-center justify-center text-xs text-foreground-300 group-hover:text-accent-500">
            <i className="ri-file-text-line"></i>
          </span>
          <span className="truncate">{chapter.title}</span>
        </Link>
      ))}
    </div>
  );
}